import { render, staticRenderFns } from "./ReportOrderSkuSerial.vue?vue&type=template&id=c8be829e"
import script from "./ReportOrderSkuSerial.vue?vue&type=script&lang=js"
export * from "./ReportOrderSkuSerial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports